module.exports = __webpack_public_path__ + "static/mockup_phone_landing@3x-a6b1713790c9f90216c95c12aa230dda.png";